import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useCurrentUser } from 'customHooks/useCurrentUser';

const useIntercom = () => {
    const currentUser = useCurrentUser();

    useEffect(() => {
        if (currentUser.intercom_hash) {
            Intercom({
                app_id: import.meta.env.VITE_DASHBOARD_INTERCOM_APP_ID,
                user_hash: currentUser.intercom_hash,
                user_id: currentUser.uid,
            });
        }
    }, [currentUser]);
};

export { useIntercom };
